import { render, staticRenderFns } from "./SBSupplementsAddEdit.vue?vue&type=template&id=69de52ec"
import script from "./SBSupplementsAddEdit.vue?vue&type=script&lang=js"
export * from "./SBSupplementsAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports